import {
  Tabs,
  Card,
  ButtonGroup,
  Button,
  TextStyle,
  Badge
} from '@superops/ui-design-system';
import { Tooltip } from 'react-clone-tippy';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { useMutation } from '@apollo/client';
import { SVGIcon } from '@superops/super-icons';
import {
  CREATE_WORKLOG_FROM_TIMERS,
  DELETE_WORKLOG_TIMER,
  GET_ALL_TIMER_ENTRIES,
  MockTicketClient,
  TicketClient,
  UPDATE_WORKLOG_TIMER_ENTRY
} from '@nile/graphql';
import { isEmpty } from 'lodash';
import { useStopwatch } from 'react-timer-hook';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import {
  COMMON_CONSTANTS,
  DeleteModal,
  EventEmitter,
  EventEmitterWithIndex,
  Loader,
  getCurrentUserHook,
  getTranslatedText,
  sendMessageToContentJS,
  toast,
  useActivityTracker,
  useProduct
} from '@nile/components';
import { removePropertiesForItProduct } from '@nile/itsm';
import WorklogAutoTimer from './WorklogAutoTimer';
import WorklogManualTimer from './WorklogManualTimer';
import TimerList, { EditTimer } from './TimerList';
import Timer from './Timer';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const Wrapper = styled.div`
  .Superops-Tabs__Wrapper,
  .Superops-Tabs__WrapperPadded {
    border-bottom: 1px solid #0000001d;
    padding: 0 20px;
    background: inherit !important;
  }
  .Superops-Card {
    background: ${(props) =>
      props.highlight
        ? 'var(--sops-worklog-timer-card-highlight-background)'
        : ''} ;
    transition: background: 200ms linear;

    ${(props) => (props?.noBoxShadow ? 'box-shadow: none;' : '')}
  }
  .timer-actions {
    right: 15px;
    top: 13px;
  }
`;

class WorklogHoursSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0,
      highlight: false
    };
  }

  componentDidMount() {
    // EventEmitter.subscribe('highlightTimer', this.highlightTimer);
    // EventEmitter.subscribe('resetTimerHighlight', this.resetTimerHighlight);
  }

  componentWillUnmount() {
    // EventEmitter.unsubscribe('highlightTimer');
    // EventEmitter.unsubscribe('resetTimerHighlight');
  }

  highlightTimer = () => {
    console.log('highlighting');
    this.setState({ highlight: true });
    // setHighlightTimer(true);
  };

  resetTimerHighlight = () => {
    this.setState({ highlight: false });
    // setHighlightTimer(false);
  };

  handleTabChange = (selectedTabIndex) => {
    this.setState({ selected: selectedTabIndex });
    if (selectedTabIndex) this.resetTimerHighlight();
    if (this.props?.onTabChange) this.props.onTabChange();
  };

  render() {
    const { selected, highlight } = this.state;
    return (
      <WorklogHoursSectionComponent
        {...this.props}
        selected={selected}
        highlight={highlight}
        handleTabChange={this.handleTabChange}
        highlightTimer={this.highlightTimer}
        resetTimerHighlight={this.resetTimerHighlight}
        hideWorklogTask={this.props?.hideWorklogTask}
        taskViewOnly={this.props?.taskViewOnly}
      />
    );
  }
}

function WorklogHoursSectionComponent(props) {
  const {
    timer,
    onlyAuto,
    onlyManual,
    workItem,
    ticket,
    project,
    module,
    refetch,
    selected,
    highlight,
    handleTabChange,
    associateWorkItem,
    noBoxShadow,
    editMode,
    showAlltimersList,
    highlightTimer,
    resetTimerHighlight,
    highlightRunningTimer,
    manualTimerAssociateWorkItem,
    adjustDeleteButton,
    disableCloseOnSuccess,
    disableAutoTimerCloseOnSuccess,
    disableManualTimerCloseOnSuccess,
    aiWorklogNotes,
    timerNote,
    repositionPopup,
    autoFocusTimerNotes,
    taskId,
    hideWorklogTask,
    editWorklogZIndex,
    hideTaskWorkItem,
    taskViewOnly,
    hideBlockItemConsumptionInfo
  } = props;
  const [currentTimer, setCurrentTimer] = useState(timer);
  const [allTimerEntries, setAllTimerEntries] = useState([]);
  const [showNewTimerForm, setShowNewTimerForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const tabRef = useRef();
  const currentTimerRef = useRef();
  const intl = useIntl();
  const user = getCurrentUserHook();

  tabRef.current = useContext(TicketContext);
  currentTimerRef.current = currentTimer;

  const runningTimers = allTimerEntries?.filter((tmer) => tmer?.running);
  // const [selected, setSelected] = useState(0);
  // const [highlight, setHighlightTimer] = useState(false);

  // const handleTabChange = useCallback((selectedTabIndex) => {
  //   setSelected(selectedTabIndex);
  //   setHighlightTimer(false);
  // }, []);

  const isItProduct = useCheckIsItProduct();

  const getAllTimerEntries = () => {
    setLoading(true);
    const operands = [
      {
        attribute: 'technician.userId',
        operator: 'is',
        value: user?.userId
      }
    ];
    if (workItem?.workId) {
      operands.push({
        attribute: 'workItem.workId',
        operator: 'is',
        value: workItem?.workId
      });
    }
    if (taskId) {
      operands.push({
        attribute: 'task.taskId',
        operator: 'is',
        value: taskId
      });
    }

    const worklogTimerInput = {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: operands
        }
      }
    };
    if (workItem?.module || module) {
      worklogTimerInput.module = workItem?.module || module;
    }
    // MockTicketClient.query({
    TicketClient.query({
      query: GET_ALL_TIMER_ENTRIES,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      variables: {
        isItProduct,
        worklogTimerInput: worklogTimerInput
      }
    }).then((res) => {
      setAllTimerEntries(res.data?.fetchWorklogTimerEntries?.entries);
      if (highlightRunningTimer && !editMode) {
        const runningTimer = res.data?.fetchWorklogTimerEntries?.entries.find(
          (worklogTimer) => {
            return worklogTimer?.running;
          }
        );
        if (runningTimer) {
          setCurrentTimer(runningTimer);
          handleTabChange(0);
        } else {
          setCurrentTimer(null);
        }
      }
      setLoading(false);
    });
  };

  const getTimerEntry = (timerId) => {
    setLoading(true);
    const operands = [
      {
        attribute: 'technician.userId',
        operator: 'is',
        value: user?.userId
      }
    ];
    if (timerId) {
      operands.push({
        attribute: 'timerId',
        operator: 'is',
        value: timerId
      });
    }
    const worklogTimerInput = {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: operands
        }
      }
    };
    if (timer?.module || timer?.workItem?.module) {
      worklogTimerInput.module = timer?.module || timer?.workItem?.module;
    }
    // MockTicketClient.query({
    TicketClient.query({
      query: GET_ALL_TIMER_ENTRIES,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      variables: { isItProduct, worklogTimerInput: worklogTimerInput }
    }).then((res) => {
      // setAllTimerEntries(res.data?.fetchWorklogTimerEntries?.entries);
      setCurrentTimer(res.data?.fetchWorklogTimerEntries?.entries[0]);
      setLoading(false);
    });
  };

  const [
    createWorklogEntryFromTimer,
    {
      loading: createWorklogEntryFromTimerLoading,
      data: worklogEntry,
      error: createWorklogEntryFromTimerError
    }
  ] = useMutation(CREATE_WORKLOG_FROM_TIMERS, {
    onCompleted({ createWorklogEntriesFromTimers: createdWorklog }) {
      if (createdWorklog) {
        toast('success', 'worklog.create.from.timer.success.toast');
        useActivityTracker({
          event: 'Ticket - Adding a time entry on tickets'
        });
        EventEmitterWithIndex.dispatch('refetchWorklogs');
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        sendMessageToContentJS('refetchGlobalTimers');

        getAllTimerEntries();
      }
    }
  });

  function bulkCreateWorklog() {
    const input = allTimerEntries
      .filter((timr) => !timr.running)
      .filter((timr) => !isEmpty(timr.notes))
      .map((timr) => ({ timerId: timr.timerId }));
    if (input?.length) {
      createWorklogEntryFromTimer({
        variables: {
          input: input
        }
      }).then((res) => {
        if (showNewTimerForm) setShowNewTimerForm(false);
      });
    }
  }

  function toggleNewTimer() {
    handleTabChange(0);
    setShowNewTimerForm(!showNewTimerForm);
  }

  useEffect(() => {
    if (editMode) {
      if (timer?.timerId) {
        getTimerEntry(timer?.timerId);
      }
      if (
        timer?.running &&
        currentTimer?.type === 'AUTOMATIC' &&
        selected === 0
      ) {
        highlightTimer();
      } else {
        resetTimerHighlight();
      }
    }
  }, [selected, editMode, timer?.timerId, timer?.running, currentTimer?.type]);

  useEffect(() => {
    if (runningTimers.length && showAlltimersList) {
      setShowNewTimerForm(false);
    }
  }, [runningTimers]);

  useEffect(() => {
    if (showAlltimersList) {
      getAllTimerEntries();
      EventEmitter.subscribe('refetchTimerEntries', getAllTimerEntries);
      const eventIndex = EventEmitterWithIndex.subscribe(
        'refetchTimerEntries',
        getAllTimerEntries
      );
      return function cleanup() {
        EventEmitter.unsubscribe('refetchTimerEntries');
        EventEmitterWithIndex.unsubscribe('refetchTimerEntries', eventIndex);
      };
    }
  }, []);

  const tabs = [
    {
      id: 'AUTO_TIMER',
      content: <FormattedMessage id="worklog.details.timer.auto" />,
      accessibilityLabel: 'Auto timer',
      panelID: 'AUTO_TIMER',
      component: (properties) => (
        <WorklogAutoTimer
          {...properties}
          timer={currentTimerRef.current}
          ticket={ticket}
          project={project}
          module={module}
          refetch={refetch}
          refetchTimerEntry={getTimerEntry}
          refetchTimerEntries={getAllTimerEntries}
          associateWorkItem={associateWorkItem}
          highlightTimer={highlightTimer}
          resetTimerHighlight={resetTimerHighlight}
          allTimerEntries={allTimerEntries}
          disableAutoTimerCloseOnSuccess={disableAutoTimerCloseOnSuccess}
          disableCloseOnSuccess={disableCloseOnSuccess}
          aiWorklogNotes={aiWorklogNotes}
          timerNote={timerNote}
          repositionPopup={repositionPopup}
          autoFocusTimerNotes={autoFocusTimerNotes}
          taskId={taskId}
          hideWorklogTask={hideWorklogTask}
          hideTaskWorkItem={hideTaskWorkItem}
          taskViewOnly={taskViewOnly}
          hideBlockItemConsumptionInfo={hideBlockItemConsumptionInfo}
        />
      )
    },
    {
      id: 'MANUAL_TIMER',
      content: <FormattedMessage id="worklog.details.timer.manual" />,
      accessibilityLabel: 'Manual timer',
      panelID: 'MANUAL_TIMER',
      component: (properties) => {
        let hideWorkitem = properties?.hideWorkitem;
        if (manualTimerAssociateWorkItem) {
          hideWorkitem = false;
        }
        return (
          <WorklogManualTimer
            {...properties}
            timer={currentTimerRef.current}
            ticket={ticket}
            project={project}
            module={module}
            refetchTimerEntry={getTimerEntry}
            refetchTimerEntries={getAllTimerEntries}
            associateWorkItem={
              associateWorkItem || manualTimerAssociateWorkItem
            }
            allTimerEntries={allTimerEntries}
            hideWorkitem={hideWorkitem}
            disableManualTimerCloseOnSuccess={disableManualTimerCloseOnSuccess}
            disableCloseOnSuccess={disableCloseOnSuccess}
            aiWorklogNotes={aiWorklogNotes}
            timerNote={timerNote}
            repositionPopup={repositionPopup}
            taskId={taskId}
            hideWorklogTask={hideWorklogTask}
            hideTaskWorkItem={hideTaskWorkItem}
            taskViewOnly={taskViewOnly}
            hideBlockItemConsumptionInfo={hideBlockItemConsumptionInfo}
          />
        );
      }
    }
  ].filter((tab) => {
    if (onlyAuto) {
      return tab.id === 'AUTO_TIMER';
    }
    if (onlyManual || (currentTimer?.type === 'MANUAL' && editMode)) {
      if (selected) handleTabChange(0);
      return tab.id === 'MANUAL_TIMER';
    }
    return true;
  });
  // if (loading) {
  //   return (
  //     <Wrapper className="full-width">
  //       <Card>
  //         <Loader />
  //       </Card>
  //     </Wrapper>
  //   );
  // }
  // if (data?.fetchWorklogEntries?.entries?.length) {
  //   return <div>Already there</div>;
  // }

  return (
    <Wrapper
      noBoxShadow={noBoxShadow}
      adjustDeleteButton={adjustDeleteButton}
      className="fx fcol g10 full-width position-relative"
      highlight={highlight}
      hideCancel={props?.hideCancel}
    >
      {showAlltimersList ? (
        !allTimerEntries.length || runningTimers?.length ? (
          <Card>
            <Tabs
              topBorder
              tabs={tabs}
              selected={selected}
              onSelect={handleTabChange}
            >
              <div>
                {tabs[selected]?.component({ ...props, hideCancel: true }) ||
                  tabs[0]?.component({ ...props, hideCancel: true })}
              </div>
            </Tabs>
          </Card>
        ) : null
      ) : (
        <Card>
          <Tabs
            topBorder
            tabs={tabs}
            selected={selected}
            onSelect={handleTabChange}
          >
            <div>
              {tabs[selected]?.component(props) || tabs[0]?.component(props)}
            </div>
          </Tabs>
        </Card>
      )}
      {showAlltimersList &&
      allTimerEntries?.filter((tmer) => !tmer?.running).length ? (
        <div className="position-relative">
          <div className="white-to-grey-bg br10 nobottomradius">
            <div className="fx actr pt10 pr10 pb10 pl20">
              <TextStyle weight="Bold">
                <FormattedMessage id="running.timers.list.mytimers.title" />
              </TextStyle>
              <span className="fx actr mlauto">
                <ButtonGroup>
                  <Tooltip
                    title={getTranslatedText(intl, 'timer.initiate.new')}
                    position="top-start"
                    inertia
                    className="full-width"
                    trigger="mouseenter"
                    animation="shift"
                    animateFill={false}
                  >
                    <Button
                      // icon={<SVGIcon name="AssociateEntity" />}
                      icon={<SVGIcon name="InitiateTimer" />}
                      onClick={toggleNewTimer}
                      disabled={runningTimers?.length}
                    />
                  </Tooltip>
                  <Tooltip
                    title={getTranslatedText(
                      intl,
                      'workItem.details.worklog.timer.addAsWorklog'
                    )}
                    position="top-start"
                    inertia
                    className="full-width"
                    trigger="mouseenter"
                    animation="shift"
                    animateFill={false}
                  >
                    <Button
                      icon={<SVGIcon name="Worklog" />}
                      onClick={bulkCreateWorklog}
                      loading={createWorklogEntryFromTimerLoading}
                      disabled={
                        !allTimerEntries
                          ?.filter((tmer) => !tmer?.running)
                          ?.filter((tmer) => !isEmpty(tmer.notes))?.length
                      }
                    />
                  </Tooltip>
                </ButtonGroup>
              </span>
            </div>
            <div className="fx fcol fw position-relative">
              {loading && (
                <div className="bg-white opacity4 loading-state fw fhp position-absolute l0 top-0" />
              )}
              {allTimerEntries
                ?.filter((tmer) => {
                  if (highlightRunningTimer) {
                    return !tmer?.running;
                  }
                  return true;
                })
                ?.map((timerEntry, i) => {
                  return (
                    <ActiveTimer
                      intl={intl}
                      timer={timerEntry}
                      refetchEntries={getAllTimerEntries}
                      tabRef={tabRef}
                      parentClassName="br10 "
                      isFirstChild={i === 0}
                      hideWorklogTask={hideWorklogTask}
                      editWorklogZIndex={editWorklogZIndex}
                      hideTaskWorkItem={hideTaskWorkItem}
                      taskViewOnly={taskViewOnly}
                      hideBlockItemConsumptionInfo={
                        hideBlockItemConsumptionInfo
                      }
                    />
                  );
                })}
              {/* )} */}
            </div>
          </div>
        </div>
      ) : null}
      {showAlltimersList && showNewTimerForm && !runningTimers.length ? (
        <Card>
          <Tabs
            topBorder
            tabs={tabs}
            selected={selected}
            onSelect={handleTabChange}
          >
            <div className="position-relative">
              {tabs[selected]?.component({ ...props, hideCancel: true }) ||
                tabs[0]?.component({ ...props, hideCancel: true })}
            </div>
          </Tabs>
        </Card>
      ) : null}
    </Wrapper>
  );
}

export default WorklogHoursSection;

const ActiveTimer = (props) => {
  const {
    intl,
    timer,
    refetchEntries,
    hideWorklogTask,
    editWorklogZIndex,
    hideTaskWorkItem,
    taskViewOnly,
    hideBlockItemConsumptionInfo
  } = props;
  const { timespent, running, workItem, type, notes } = timer;

  const autoTimer = type === 'AUTOMATIC';

  const [
    updateWorklogTimerEntryWithInterceptor,
    {
      loading: updateWorklogTimerEntryLoading,
      data: updatedWorklogTimerEntry,
      error: updateWorklogTimerEntryError
    }
  ] = useMutation(UPDATE_WORKLOG_TIMER_ENTRY, {
    onCompleted({ updateWorklogTimerEntry: currentCreatedTimer }) {
      if (currentCreatedTimer) {
        // EventEmitter.dispatch('refetchWorklogTimers');
        if (!isEmpty(timer?.task)) {
          // Refetch timer in ticket/project when edit timer is started from task
          EventEmitterWithIndex.dispatch('refetchTimerEntries');
        }
        refetchEntries();
        sendMessageToContentJS('refetchGlobalTimers');
        toast('success', 'timer.entry.update.success.toast');
      }
    }
  });
  const currentProduct = useProduct();

  async function updateWorklogTimerEntry(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'updateWorklogTimerEntry',
        currentProduct
      );
      return await updateWorklogTimerEntryWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  // const [
  //   deleteWorklogTimerEntry,
  //   {
  //     loading: deleteWorklogTimerEntryLoading,
  //     data: deletedEntry,
  //     error: deleteWorklogTimerEntryError
  //   }
  // ] = useMutation(DELETE_WORKLOG_TIMER, {
  //   onCompleted(res) {
  //     if (res?.deleteWorklogTimerEntry) {
  //       refetchEntries();
  //       EventEmitter.dispatch('refetchGlobalTimers');
  //     }
  //   }
  // });

  const handleAssociateWorkItem = (module, workItem) => {
    useActivityTracker({
      event:
        module === 'TICKET' ? 'Associated to ticket' : 'Associated to project'
    });
    updateWorklogTimerEntry({
      variables: {
        timerEntryInput: {
          timerId: timer?.timerId,
          workItem: {
            workId: workItem?.entityId,
            module: module
          }
        }
      }
    });
  };

  const formatTime = (time) => {
    return String(time).padStart(2, '0');
  };

  let stopwatchOffset = new Date();
  stopwatchOffset.setSeconds(stopwatchOffset.getSeconds() + timespent);
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    reset
  } = useStopwatch({
    autoStart: running,
    offsetTimestamp: stopwatchOffset
  });

  useEffect(() => {
    stopwatchOffset = new Date();
    stopwatchOffset.setSeconds(stopwatchOffset.getSeconds() + timespent);
    reset(stopwatchOffset, running);
  }, [timespent, running]);

  return (
    <div
      className={`white-to-grey-bg p10 fx actr position-relative border-bottom ${
        props?.isFirstChild ? 'border-top' : ''
      }`}
      key={timer?.timerId}
    >
      {updateWorklogTimerEntryLoading && (
        <div className="bg-white opacity4 loading-state fw fhp position-absolute l0 top-0" />
      )}
      {/* {timer?.type && !autoTimer ? (
        <span className="timer-type pr5 pl5 br10 capitalize position-absolute">
          {timer?.type}
        </span>
      ) : null} */}

      <Timer
        timer={timer}
        updateWorklogTimerEntry={updateWorklogTimerEntry}
        updateWorklogTimerEntryLoading={updateWorklogTimerEntryLoading}
      />
      <div className="ml-5 cw-160 ellipsis">
        {notes ? (
          notes
        ) : (
          <Tooltip
            title={getTranslatedText(intl, 'timer.add.note.to.convert')}
            position="top-start"
            inertia
            className="full-width"
            trigger="mouseenter"
            animation="shift"
            animateFill={false}
          >
            <Badge
              size="large"
              icon={<SVGIcon name="WarningOutline" size="sm" />}
              iconPosition="left"
              status="attention"
            >
              <FormattedMessage id="workItem.details.add.note" />
            </Badge>
          </Tooltip>
        )}
      </div>

      <EditTimer
        timer={timer}
        autoTimer={autoTimer}
        associateWorkItem={false}
        handleAssociateWorkItem={handleAssociateWorkItem}
        handleParentClose={() => {}}
        hideWorklogTask={hideWorklogTask}
        editWorklogZIndex={editWorklogZIndex}
        hideTaskWorkItem={hideTaskWorkItem}
        taskViewOnly={taskViewOnly}
        hideBlockItemConsumptionInfo={hideBlockItemConsumptionInfo}
      />

      {/* <DeleteModal
        modalActivator={
          <span className="ptr ml-5">
            <SVGIcon name="Delete" size="sm" />
          </span>
        }
        title={getTranslatedText(intl, 'timer.unknown.delete.title')}
        handleDeleteConfirmation={() => {
          deleteWorklogTimerEntry({
            variables: {
              deleteWorklogTimerInput: {
                timerId: timer?.timerId
              }
            }
          });
        }}
        description={getTranslatedText(
          intl,
          'timer.unknown.delete.description'
        )}
      /> */}
    </div>
  );
};

export const TimeCollector = styled.div.attrs({
  className: 'ptr fx center'
})`
  background: ${(props) => (props.highlight ? '#F7D4F3' : '#f0f0f880')};
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;
  min-height: 38px;
  min-width: 60px;

  .Superops-TextField__Prefix,
  .Superops-TextField__Suffix {
    border-bottom: none !important;
    background: none !important;
  }
  .value_selector__control {
    background: none !important;
    border-bottom: none !important;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField {
    background: transparent;
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-bottom: 0;
    border-bottom: 0 !important;
  }
  .Superops-TextField--multiline > .Superops-TextField__Input {
    padding-top: 6px;
  }
`;
